import React from 'react'
import {bindActionCreators} from 'redux'
import {connect} from 'react-redux'

import {fetchDataIfReady} from '../modules/fetch.action.js'
import {time_ago_txt} from 'Skelet/src/modules/time_ago.js'

const e = React.createElement;


function SettingsDevices(props) {
  React.Component.constructor.call(this);

  this.state = {};
}
SettingsDevices.prototype = Object.create(React.Component.prototype);

SettingsDevices.prototype.componentWillMount = function() {
  this.props.fetchDataIfReady(this.props.config.api_token, "devices", "GET", this.props.config.api_url+"/devices?t="+this.props.session_token);
}


SettingsDevices.prototype.render = function() {
  var devices_list = [];
  var device_list = this.props.apiData["devices"];
  if(device_list !== undefined && device_list.data !== undefined && device_list.data !== null && device_list.data[0] !== undefined) {
    for(var i = 0; i < device_list.data.length; i++) {
      var dv = device_list.data[i];
      var dv_cd = time_ago_txt(dv.created_at);
      devices_list[i] = e('div', {key:i, className:"contact notification"}, [e('div', {className:"contact-name"}, ""+dv.browser_name+" on "+dv.os), e('small', {style:{opacity:".5", display:"block", fontSize:"75%"}}, "registratie: "+dv_cd)]);
    }
  }

  return e('div', null, [e('strong', {key:"settings-title"}, "Apparaten"), e('div', {key:"settings-form", className:"card settings contacts"}, e('form', {onSubmit:function(e) {this.handleCreate(e)}.bind(this)}, devices_list))]);
}


function mapStateToProps(state) {
  var session_token = null, is_fetching = null;
  if(state.apiData["login"] !== undefined && (state.apiData["login"]["data"]["token"] !== undefined || state.apiData["login"]["data"]["token"] === null)) {
    session_token = state.apiData["login"]["data"]["token"];
  }
  if(state.apiData["devices"] !== undefined && state.apiData["devices"].isFetching !== undefined) {
    is_fetching = state.apiData["devices"].isFetching;
  }

  return {
    session_token: session_token,
    is_fetching: is_fetching,
    apiData: state.apiData,
  }
}

function mapDispatchToProps(dispatch){
  return bindActionCreators({
    fetchDataIfReady,
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(SettingsDevices)



//////////////////
// WEBPACK FOOTER
// ../_Skelet/src/components/SettingsDevices.js
// module id = 189
// module chunks = 0